import { RouterProvider, createBrowserRouter } from "react-router-dom";
import EPassPage from "./pages/EPass";
import "./App.css";
import GetQrPage from "./pages/GetQR";
import { LanguageProvider } from "./context/LanguageContext";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import EntryNew from "./pages/EntryNew";
// import DashBoard from "./pages/DashBoard";
import TransitionHistory from "./pages/TransitionHistory";
import ScanningHistory from "./pages/ScanningHistory";
import Projections from "./pages/Projections";
import DigitalProduct from "./pages/DigitalProduct";
import LoginPage from "./pages/Login";
import AshramDailySchedule from "./pages/AshramDailySchedule";
import WellnessRetreat from "./pages/WellnessRetreat";
import Usa from "./pages/Usa";
import SpringPage from "./pages/SpringPage";
import EntryNewOne from "./pages/EntryNewOne";
import DashBoardNew from "./pages/DashBoardNew";
import AshramCulture from "./pages/AshramCulture";
import DashBoard from "./pages/DashBoard";
import PlannerAdmin from "./pages/PlannerAdmin";
import DashBoardData from "./pages/DashBoardData";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <div className="h-screen flex flex-col justify-center items-center">
          <h3 className="text-2xl">Invalid URL</h3>
          <p>Please enter a valid ePass URL</p>
        </div>
      ),
    },
    {
      path: "/login",
      element: <LoginPage />,
      title: "Login",
    },
    {
      path: "/epass/:passId",
      element: <EPassPage />,
      title: "EPass Page",
    },
    {
      path: "/projections",
      element: <Projections />,
      title: "Food",
    },
    {
      path: "/usa/april-shibir",
      element: <Usa />,
      title: "April Shibir",
    },
    {
      path: "/usa/shibir-with-pujya-gurudevshri",
      element: <SpringPage />,
      title: "Shibir with Pujya Gurudevshri",
    },
    {
      path: "/getQr/:passId",
      element: <GetQrPage />,
      title: "Get QR Page",
    },
    // {
    //   path: "/entry",
    //   element: <EntryNew />,
    //   title: "Entry Page",
    // },
      {
      path: "/entry",
      element: <EntryNewOne />,
      title: "Entry Page",
    },
    // {
    //   path: "/visitorPortal",
    //   element: (
    //     <div className="h-screen flex flex-col justify-center items-center">
    //       <h3 className="text-2xl">Invalid URL</h3>
    //       <p>Please enter a valid visitorPortal URL</p>
    //     </div>
    //   ),
    // },
    {
      path: "/visitorPortal",
      element: <DashBoardData />,
    },
    {
      path: "/visitorPortal-old/:passId",
      element: <DashBoard />,
      title: "DashBoard Page",
    },
    {
      path: "/visitorPortal/:passId",
      element: <DashBoardNew />,
      title: "DashBoard Page",
    },
    {
      path: "/ashram-culture",
      element: <AshramCulture />,
      title: "DashBoard Page",
    },
    {
      path: "/transactionHistory",
      element: (
        <div className="h-screen flex flex-col justify-center items-center">
          <h3 className="text-2xl">Invalid URL</h3>
          <p>Please enter a valid Transaction history URL</p>
        </div>
      ),
    },
    {
      path: "/transactionHistory/:passId",
      element: <TransitionHistory />,
      title: "Transaction history",
    },
    {
      path: "/scanningHistory",
      element: (
        <div className="h-screen flex flex-col justify-center items-center">
          <h3 className="text-2xl">Invalid URL</h3>
          <p>Please enter a valid Scanning history URL</p>
        </div>
      ),
    },
    {
      path: "/scanningHistory/:passId",
      element: <ScanningHistory />,
      title: "Scanning history",
    },
    {
      path: "/activateDigitalProduct",
      element: <DigitalProduct />,
      title: "Digital Product",
    },
    {
      path: "/AshramDailySchedule",
      element: <AshramDailySchedule />,
      title: "Ashram Daily Schedule",
    },
    {
      path: "/usa/yoga-retreat",
      element: <WellnessRetreat />,
      title: "Yoga Retreat",
    },
    {
      path: "/plannerAdmin",
      element: <PlannerAdmin />,
      title: "Planner Admin",
    },
  ]);
  return (
    <LanguageProvider>
      <HelmetProvider>
        <RouterProvider router={router}>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Shrimad Rajchandra Mission Dharampur</title>{" "}
            {/* Default title for the app */}
          </Helmet>
          <ToastContainer />
        </RouterProvider>
      </HelmetProvider>
    </LanguageProvider>
  );
};

export default App;
